import React from 'react';
import { Table, Tag } from 'antd';
import { Columns } from "./config";
import { Animated } from "../../../Modules/pme/screens/dashboard/widgets/tasks";
import { getLocales } from '../../../../components/Table/newTable';

/**
 *
 * @param {type} type of severity
 * @param {t} translations
 */
export const getSeverity = ({ t, type }) => {
  switch (type) {
    case 'minor':
      return <Tag color="yellow" style={{ width: 80, textAlign: 'center' }}>{t('Minor')}</Tag>
    case 'major':
      return <Tag color="red" style={{ width: 80, textAlign: 'center' }}>{t('Major')}</Tag>
    case 'moderate':
      return <Tag color="orange" style={{ width: 80, textAlign: 'center' }}>{t('Moderate')}</Tag>
    default:
      return null;
  }
}

/**
 *
 * @param {type} type of severity
 * @param {t} translations
 */
export const renderSeverity = ({ center = true, type, t = (s) => s }) => {
  const severity = getSeverity({ t, type });
  return severity ? <div style={center ? { display: 'flex', justifyContent: 'center' } : null}>{severity}</div> : null;
};

/**
 *
 * @param {*} type type of tag
 * @param {*} text text of label
 * @param {*} textColor color of label
 * @param {*} t translations
 * @returns
 */
const getTag = ({ text = null, textColor = null, t, background, borderColor }) => {
  return typeof text === 'string' ? (
    <Tag
      style={{
        marginBottom: 0,
        color: textColor || '#4D5761',
        borderColor: borderColor || '#D2D6DB',
        textAlign: 'center',
        background,
        width: 100,
      }}
    >
      {t(text)}
    </Tag>
  ) : null;
}

/**
 *
 * @param {*} tab type of tab
 * @param {*} status type of status
 * @returns
 */
export const renderStatus = ({ tab, status, options, t, style }) => {
  if (options?.consolidation) {
    switch (options.consolidation) {
      case 'verified':
        if (status === 'comply') {
          status = 'positiveVerified'
        } else if (status === 'gap') {
          status = 'negativeVerified'
        }
        break;
      case 'unverified':
        if (status === 'comply') {
          status = 'positiveUnverified'
        } else if (status === 'gap') {
          status = 'negativeUnverified'
        }
        break;
      case 'contested':
        if (status === 'comply') {
          status = 'positiveContested'
        } else if (status === 'gap') {
          status = 'negativeContested'
        }
        break;
      default:
        break;
    }
  }

  const getT = () => {
    if (options && options.isMineral) {
      switch (status) {
        case 'high':
          return getTag({
            text: 'High',
            t: t,
          });
        case 'medium':
          return getTag({
            text: 'Medium',
            t: t,
          });
        case 'low':
          return getTag({
            text: 'Low',
            t: t,
          });
        default:
      }
    } else {
      let text = '';

      switch (status) {
        case 'comply':
          return getTag({
            text: 'Comply',
            t: t,
            textColor: '#52C41A',
            background: '#F6FFED',
            borderColor: '#B7EB8F',
          });
        case 'complyVerified':
        case 'verifiedComply':
          return (
            <>
              {getTag({
                text: 'Comply',
                t: t,
                textColor: '#52C41A',
                background: '#F6FFED',
                borderColor: '#B7EB8F',
              })}
              {getTag({
                text: 'TableComponents::Verified',
                textColor: '#52C41A',
                background: '#D9F7BE',
                borderColor: '#B7EB8F',
                t: t,
              })}
            </>
          )
        case 'complyUnverified':
        case 'unverifiedComply':
          return (
            <>
              {getTag({
                text: 'Comply',
                t: t,
                textColor: '#52C41A',
                background: '#F6FFED',
                borderColor: '#B7EB8F',
              })}
              {getTag({
                text: 'TableComponents::Unverified',
                textColor: '#52C41A',
                background: '#D9F7BE',
                borderColor: '#B7EB8F',
                t: t,
              })}
            </>
          )
        case 'gapVerified':
        case 'verifiedGap':
          return (
            <>
              {getTag({
                text: 'Gap',
                t,
                textColor: '#F5222D',
                background: '#FFF1F0',
                borderColor: '#FFA39E',
              })}
              {getTag({
                text: 'TableComponents::Verified',
                textColor: '#CF1322',
                background: '#FFCCC7',
                borderColor: '#FF7875',
                t,
              })}
            </>
          );
        case 'gapUnverified':
        case 'unverifiedGap':
          return (
            <>
              {getTag({
                text: 'Gap',
                t,
                textColor: '#F5222D',
                background: '#FFF1F0',
                borderColor: '#FFA39E',
              })}
              {getTag({
                text: 'TableComponents::Unverified',
                textColor: '#CF1322',
                background: '#FFCCC7',
                borderColor: '#FF7875',

                t,
              })}
            </>
          );
        case 'gap':
          return getTag({
            text: 'Gap',
            t,
            textColor: '#F5222D',
            background: '#FFF1F0',
            borderColor: '#FFA39E',
          });
        case 'fail':
          return getTag({
            text: 'Fail',
            t: t,
            textColor: '#F5222D',
            background: '#FFF1F0',
            borderColor: '#FFA39E',
          });
        case 'positiveVerified':
          return getTag({
            text: 'TableComponents::Verified',
            textColor: '#52C41A',
            background: '#D9F7BE',
            borderColor: '#B7EB8F',
            t: t,
          });
        case 'positiveUnverified':
          return getTag({
            text: 'TableComponents::Unverified',
            t,
            textColor: '#52C41A',
            background: '#D9F7BE',
            borderColor: '#B7EB8F',
          });
        case 'negativeVerified':
          return getTag({
            text: 'TableComponents::Verified',
            textColor: '#F5222D',
            background: '#FFCCC7',
            borderColor: '#FFA39E',
            t,
          });
        case 'negativeUnverified':
          return getTag({
            text: 'TableComponents::Unverified',
            t,
            textColor: '#F5222D',
            background: '#FFCCC7',
            borderColor: '#FFA39E',
          });
        case 'positiveContested':
          return getTag({
            text: 'Contested',
            textColor: '#FD7614',
            background: '#FFF7E6',
            borderColor: '#FFD591',
            t,
          });
        case 'negativeContested':
          return getTag({
            text: 'Contested',
            t,
            textColor: '#FD7614',
            background: '#FFF7E6',
            borderColor: '#FFD591',
          });
        case 'undetermined':
          switch (tab) {
            case 'documentationReview':
              text = 'DocumentationReview::Undetermined';
              break;
            default:
              text = 'TableComponents::Undetermined';
          }
          return getTag({
            text,
            t,
            textColor: '#FD7614',
            background: '#FFF7E6',
            borderColor: '#FFD591',
          });
        case 'undeterminedSubject':
          return getTag({
            text: 'TableComponents::Undetermined',
            t,
            textColor: '#FD7614',
            background: '#FFF7E6',
            borderColor: '#FFD591',
          });
        case 'notApplicable':
          return getTag({
            text: 'TableComponents::Not Applicable',
            t,
            textColor: '#4D5761',
            background: '#F9FAFB',
          });
        case 'available':
          return getTag({
            text: 'Available',
            t,
            textColor: '#52C41A',
            background: '#F6FFED',
            borderColor: '#B7EB8F',
          });
        case 'uponRequest':
          return getTag({
            text: 'Request',
            t,
            textColor: '#FD7614',
            background: '#FFF7E6',
            borderColor: '#FFD591',
          });
        case 'unavailable':
          return getTag({
            text: 'TableComponents::Unavailable',
            t,
            textColor: '#F5222D',
            background: '#FFF1F0',
            borderColor: '#FFA39E',
          });
        case 'noData':
          return getTag({ type: 'noData', text: 'No Data', t, tooltip: 'Information missing' });
        default:
          switch (tab) {
            case 'documentationReview':
              text = 'DocumentationReview::Undetermined';
              break;
            default:
              text = 'TableComponents::Undetermined';
          }
          return getTag({
            text,
            t,
            textColor: '#FD7614',
            background: '#FFF7E6',
          });
      }
    }

    return null;
  }

  const tag = getT();

  return tag ? (
    <div style={style}>
      {tag}
    </div>
  ) : null;
};

/**
 *
 * @param {*} isExpandable is multiple or not
 * @param {*} namespace type of config
 * @param {*} t translations
 * @param {*} expandActions actions like toggle, untogle, expanded keys
 * @param {*} modalActions modal actions
 * @returns
 */
export const getColumns = ({
  isExpandable,
  namespace,
  t = (s) => s,
  expandActions,
  actions = {},
}) => {
  const columns = Columns({ t, expandActions, isExpandable, actions });
  if (columns[namespace]) {
    return columns[namespace];
  }
  return [];
};

/**
 *
 * @param {*} namespace type of table
 * @param {*} data all data
 * @param {*} modalActions table actions
 * @param {*} t translations
 * @returns
 */
export const renderRows = ({ data, expanded, columns, dataKey }) => {
  return (
    <Animated isActive={expanded.includes(data.key)}>
      <Table
        className="no-header-table"
        columns={columns}
        dataSource={(dataKey ? data[dataKey] : data.sources || data.checks || data.versions || []).map((s, i) => ({
          ...s,
          index: i,
          key: `${data.key}-${i}`,
        }))}
        expandable
        expandedRowRender={() => null}
        doInject={false}
        expandIcon={() => <button style={{ display: 'none' }} type="button" className="ant-table-row-expand-icon ant-table-row-expand-icon-spaced" aria-label="Expand row"></button>}
        pagination={false}
      />
    </Animated>
  );
};

export const getMajority = (checks) => {
  const allChecks = Object.values(checks).map((ch) => ch.severity);

  if (allChecks.includes('major')) {
    return 'major';
  }

  if (allChecks.includes('moderate')) {
    return 'moderate';
  }

  return 'minor';
};
